import ArkLoader from '@src/js/common/ark-extensions';
import componentConfig from './component-config';
import { getAidForReport } from '@tencent/txdocs-aid';
import i18n from '@i18next/i18n';
import { TDWActionType, TDWModuleType, TDWOperationType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { getVipInfo } from '../vip-linktext';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';

interface ModalToPayProps {
    position: string;
    feature: string;
    apprec: string;
    name: string,
}

export async function showModelToPay(props: ModalToPayProps): Promise<void> {
    const { position, feature, apprec, name } = props;
    const aid = getAidForReport({
        feature,
        position,
        apprec1: apprec,
    });
    tdw({
        opername: TDWOperationType.VIP_UPGRADE,
        module: TDWModuleType.POPUP,
        action: TDWActionType.SHOW,
        eventcode: `${TDWOperationType.VIP_UPGRADE}-${TDWModuleType.LINK_TEXT}-${TDWActionType.SHOW}`,
        ver5: getVipInfo(),
        ver6: feature,
        ver7: apprec,
        ver8: aid,
        ver9: `pc_${position}`,
    });
    const ocrExtension = await ArkLoader.extensionService.getExtension(componentConfig.name);
    ocrExtension.show({
        source: aid,
        rightName: name,
        noTryContent: i18n.t('开通会员即可尊享{0}特权。', { 0: name }),
        reportVers: {
            ver6: feature,
            ver7: apprec,
            ver9: `pc_${position}`,
        },
    });
}

